<template>
  <div class="pb-section-container margin-top-16">
    <div :class="['pbs-header-container', active ? 'active' : null]">
      <button
        v-if="finishedSection.includes('planDetail') && !active"
        type="button"
        class="pbs-done-button"
        @click="changeActiveStepIdx(index)"
      >
        Edit
      </button>
      <button
        v-else-if="!active"
        type="button"
        class="pbs-button"
        @click="changeActiveStepIdx(index)"
      >
        Start
      </button>
      <button v-else type="button" class="pbs-close-button" @click="changeActiveStepIdx(-1)">
        <img src="@shared/assets/img/setting/chevron-up.svg" alt="Close" />
      </button>
      <div class="pbs-header">Plan Details</div>
      <div v-if="finishedSection.includes('planDetail')" class="pbs-header-right-container">
        <div class="pbs-check-container">
          <img src="@shared/assets/img/general/check-white.png" alt="Complete" />
        </div>
      </div>
    </div>
    <div :class="['pbs-body-container detail-section', active ? 'active' : null]">
      <div class="pbs-body">
        Select, as well as add your own services that you would like to offer
      </div>
      <div class="pbs-title-container">
        <div class="pbs-title">System Inspections</div>
        <button
          class="pbs-help-button"
          type="button"
          @click="toggleInfoModal(true, 'system-inspection')"
        >
          ?
        </button>
      </div>
      <div class="pbs-sub-header">
        Select the type of inspection and how many are included in the plan.
      </div>
      <div class="flex-row align-center just-between">
        <div class="pbs-checkbox-container">
          <input id="inspection-person" v-model="inPerson" type="checkbox" class="pbs-checkbox" />
          <label for="inspection-person" class="pbs-checkbox-label"> In Person </label>
        </div>
        <input
          v-model="inspectionPerson"
          aria-label="In Person"
          class="pbs-center-input"
          placeholder="0"
          :disabled="!inPerson"
          type="number"
        />
      </div>
      <div class="flex-row align-center just-between margin-top-4">
        <div class="pbs-checkbox-container">
          <input id="inspection-virtual" v-model="virtual" type="checkbox" class="pbs-checkbox" />
          <label for="inspection-virtual" class="pbs-checkbox-label"> Virtual </label>
        </div>
        <input
          v-model="inspectionVirtual"
          aria-label="In Person"
          class="pbs-center-input"
          placeholder="0"
          :disabled="!virtual"
          type="number"
        />
      </div>
      <div class="flex-row align-center just-between margin-top-4">
        <div class="pbs-checkbox-container">
          <input id="inspection-flex" v-model="flex" type="checkbox" class="pbs-checkbox" />
          <label for="inspection-flex" class="pbs-checkbox-label"> Flex / Floating </label>
        </div>
        <input
          v-model="inspectionFlex"
          aria-label="In Person"
          class="pbs-center-input"
          placeholder="0"
          :disabled="!flex"
          type="number"
        />
      </div>
      <div class="pbs-title-container margin-top-16">
        <div class="pbs-title">Plan Benefits</div>
        <button
          class="pbs-help-button"
          type="button"
          @click="toggleInfoModal(true, 'plan-benefit')"
        >
          ?
        </button>
      </div>
      <div class="pbs-sub-header">
        A maximum of 8 benefits can be displayed. The plan benefits will be detailed in the One
        Pager. Drag and drop to place in the desired order.
      </div>
      <div class="plan-benefits-text">Benefits displayed on Plan:</div>
      <div class="line-divider" />
      <draggable
        :key="refreshId"
        class="pbs-list-included-group"
        :list="included"
        group="service"
        :move="handleMove"
        @end="handleEnd"
      >
        <div
          v-for="(s, idx) in included"
          :key="s.serviceId || s.service"
          class="pbs-list-group-item"
        >
          <img src="@shared/assets/img/setting/drag-icon.svg" class="pbs-drag-icon" alt="drag" />
          <div :class="[s.serviceId === 1 ? 'blue-text' : null, 'pbs-list-item-text']">
            {{ s.service }}
          </div>
          <div class="pbs-list-order">
            {{ idx + 1 }}
          </div>
        </div>
      </draggable>
      <div v-if="error" class="pbs-error-text">
        {{ error }}
      </div>
      <div class="plan-benefits-text">Partner's custom benefits created:</div>
      <div class="line-divider" />
      <div class="pbs-dark-title margin-top-8">Add your own service:</div>
      <div class="pbs-sub-header">
        Services listed below will not be visible on the plan. To include a service, drag and drop
        to section above.
      </div>
      <div class="pbs-input-container">
        <div class="flex-row align-center">
          <input
            v-model="service"
            class="pbs-input margin-right-4"
            placeholder="100 characters max"
            maxlength="100"
          />
          <button
            class="pbs-grey-button"
            type="button"
            :disabled="service.length === 0"
            @click="createNewService"
          >
            Add
          </button>
        </div>
        <div v-if="serviceError" class="pbs-error-text">
          {{ serviceError }}
        </div>
      </div>
      <draggable
        :key="`not-${refreshId}`"
        class="pbs-list-group margin-top-8"
        :list="notIncluded"
        group="service"
        :move="handleMove"
        @end="handleEnd"
      >
        <div
          v-for="(s, idx) in notIncluded"
          :key="s.serviceId || s.service"
          class="pbs-list-group-item"
        >
          <img src="@shared/assets/img/setting/drag-icon.svg" class="pbs-drag-icon" alt="drag" />
          <div class="pbs-list-item-text">
            {{ s.service }}
          </div>
          <button
            v-if="!s.serviceId"
            type="button"
            class="pbs-remove-btn"
            @click="removeService(idx)"
          >
            <img src="@shared/assets/img/general/x-white.png" alt="x" />
          </button>
        </div>
      </draggable>
      <div class="pbs-button-container">
        <button class="pbs-grey-button" type="button" @click="handleContinue">Continue</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { debounce } from 'lodash';
import SACToggleSwitch from '@shared/components/sac/SACToggleSwitch.vue';

import providerPlanMixin from '@shared/mixins/providerPlanMixin';

export default {
  name: 'PlanDetails',
  components: {
    draggable,
    SACToggleSwitch,
  },
  mixins: [providerPlanMixin],
  props: {
    editing: Boolean,
    corporation: Object,
    index: Number,
    active: Boolean,
    changeActiveStepIdx: Function,
    plan: Object,
    updatePlan: Function,
    finishedSection: Array,
    toggleInfoModal: Function,
    changeBuilderState: Function,
    markUnfinishedSection: Function,
    markFinishedSection: Function,
  },
  data() {
    return {
      inPerson: false,
      virtual: false,
      flex: false,
      inspectionPerson: null,
      inspectionVirtual: null,
      inspectionFlex: null,
      included: [],
      notIncluded: [],
      service: '',
      error: '',
      serviceError: '',
      refreshId: Math.random().toString(36).slice(2),
    };
  },
  watch: {
    services(newServices) {
      this.setServiceSelection(this.plan, newServices);
    },
    plan(newPlan) {
      this.inPerson = newPlan.inspectionPerson > 0;
      this.virtual = newPlan.inspectionVirtual > 0;
      this.flex = newPlan.inspectionFlex > 0;
      this.inspectionPerson = newPlan.inspectionPerson;
      this.inspectionVirtual = newPlan.inspectionVirtual;
      this.inspectionFlex = newPlan.inspectionFlex;
      this.setServiceSelection(newPlan, this.services);
    },
    inPerson(bool) {
      if (!bool) {
        this.inspectionPerson = null;
      }
      this.debouncedCheckIncomplete();
    },
    virtual(bool) {
      if (!bool) {
        this.inspectionVirtual = null;
      }
      this.debouncedCheckIncomplete();
    },
    flex(bool) {
      if (!bool) {
        this.inspectionFlex = null;
      }
      this.debouncedCheckIncomplete();
    },
    inspectionPerson() {
      this.debouncedCheckIncomplete();
    },
    inspectionVirtual() {
      this.debouncedCheckIncomplete();
    },
    inspectionFlex() {
      this.debouncedCheckIncomplete();
    },
    included() {
      this.debouncedCheckIncomplete();
    },
  },
  mounted() {
    this.setServiceSelection(this.plan, this.services);
  },
  methods: {
    handleMove(e) {
      const {
        draggedContext: { element },
        to,
      } = e;
      if (element.serviceId === 1 && JSON.stringify(to.classList).includes('pbs-list-group')) {
        this.error = "Smart sensors & installation service can't be removed.";
        return false;
      }
      const includedServices = this.included.map((s) => s.service);
      if (
        JSON.stringify(to.classList).includes('pbs-list-included-group') &&
        !includedServices.includes(element.service) &&
        this.included.length >= 8
      ) {
        this.error =
          'There can be only be 8 services. Please remove one before adding a new service.';
        return false;
      }
      if (JSON.stringify(to.classList).includes('pbs-list-group') && this.included.length === 3) {
        this.error = 'At least 3 benefits needs to be included with plan';
        return false;
      }
      this.error = '';
      return true;
    },
    handleEnd() {
      this.refreshId = Math.random().toString(36).slice(2);
    },
    createNewService() {
      this.serviceError = '';
      const allServices = [...this.included, ...this.notIncluded].map((s) => s.service);
      if (allServices.includes(this.service)) {
        this.serviceError = 'Service already exists.';
      } else {
        const newService = {
          service: this.service,
          create: true,
          planType: this.plan.planType,
          planId: this.plan.planId,
          corpId: this.plan.corpId,
        };
        if (this.included.length < 8) {
          this.included = [...this.included, newService];
        } else {
          this.notIncluded = [...this.notIncluded, newService];
        }
        this.service = '';
      }
    },
    removeService(idx) {
      const newNotIncluded = [...this.notIncluded];
      newNotIncluded.splice(idx, 1);
      this.notIncluded = newNotIncluded;
    },
    handleContinue() {
      this.error = '';
      this.changeActiveStepIdx(this.index + 1);
      const newPlan = {
        ...this.plan,
        inspectionPerson: this.inPerson ? this.inspectionPerson : null,
        inspectionVirtual: this.virtual ? this.inspectionVirtual : null,
        inspectionFlex: this.flex ? this.inspectionFlex : null,
        services: this.included.map((element) => ({
          ...element,
          planType: this.plan.planType,
          sortOrder: this.included.indexOf(element) + 1,
        })),
      };
      this.updatePlan(newPlan, 'planDetail');
    },
    setServiceSelection: debounce(function (plan, services) {
      if (plan?.services.length > 0 && this.finishedSection.includes('planDetail')) {
        const included = [...plan.services];
        const notIncluded = [];
        const filteredServices = services.filter((item) => item.planType === plan.planType);
        filteredServices.forEach((item) => {
          const includes = plan.services.find((s) => s.serviceId === item.serviceId);
          if (!includes) {
            notIncluded.push(item);
          }
        });
        this.notIncluded = notIncluded;
        if (this.included.length === 0) {
          this.included = included;
        }
      } else if (plan?.planType === 'Hardware') {
        const hardwareOnly = services.filter((item) => item.planType === 'Hardware');
        this.included = hardwareOnly.slice(0, 8);
        this.notIncluded = hardwareOnly.slice(8);
      } else if (plan?.planType === 'AppOnly') {
        const appOnly = services.filter((item) => item.planType === 'AppOnly');
        this.included = appOnly.slice(0, 8);
        this.notIncluded = appOnly.slice(8);
      } else {
        this.included = services.slice(0, 8);
        this.notIncluded = services.slice(8);
      }
    }),
    debouncedCheckIncomplete: debounce(function () {
      if (this.editing || this.finishedSection.includes('planDetail')) {
        let incomplete = false;
        const comparePerson = this.inspectionPerson || 0;
        const compareVirtual = this.inspectionVirtual || 0;
        const compareFlex = this.inspectionFlex || 0;
        const planPerson = this.plan.inspectionPerson || 0;
        const planVirtual = this.plan.inspectionVirtual || 0;
        const planFlex = this.plan.inspectionFlex || 0;
        if (
          (!this.inPerson && planPerson > 0) ||
          (this.inPerson && planPerson === 0) ||
          Number(comparePerson) !== Number(planPerson)
        ) {
          incomplete = true;
        }
        if (
          (!this.virtual && planVirtual > 0) ||
          (this.virtual && planVirtual === 0) ||
          Number(compareVirtual) !== Number(planVirtual)
        ) {
          incomplete = true;
        }
        if (
          (!this.flex && planFlex > 0) ||
          (this.flex && planFlex === 0) ||
          Number(compareFlex) !== Number(planFlex)
        ) {
          incomplete = true;
        }
        if (this.included.length > 0 && this.included.length !== this.plan.services.length) {
          incomplete = true;
        }
        if (!incomplete) {
          incomplete = this.included.reduce((acc, ser) => {
            if (acc) {
              return acc;
            }
            const alreadyIncluded = this.plan.services.find((s) => s.serviceId === ser.serviceId);
            return !alreadyIncluded;
          }, false);
        }
        if (incomplete) {
          this.markUnfinishedSection('planDetail');
        } else {
          this.markFinishedSection('planDetail');
        }
      }
    }, 500),
  },
};
</script>

<style lang="scss">
.smart-maintenance-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 5px;
}

.smart-maint-text {
  color: $N90;
  font-size: 12px;
  font-weight: 500;
  line-height: 105%;
  letter-spacing: -0.12px;
}

.line-divider {
  width: 100%;
  height: 2px;
  background-color: $N10;
  margin-bottom: 8px;
}

.plan-benefits-text {
  color: $N90;
  font-size: 12px;
  font-weight: 500;
  line-height: 105%;
  padding-top: 17.5px;
}
</style>
